export default "__VITE_ASSET__D3F9e17s__"